








































































import { Vue, Component, Prop, p } from "av-ts";
import { IQuestion } from "../../interfaces/models";
import TopicChip from "../util/TopicChip.vue";
import { roundNumber } from "../../util";

@Component({
    components: {
        TopicChip
    }
})
export default class QuestionDetails extends Vue {
    @Prop question = p<IQuestion>({
        required: true
    });

    get starIcons(): string[] {
        const value = this.question.effectiveness;
        let stars = [];
        let numberStars;

        if (value % 2 == 0) {
            numberStars = value / 2;
            stars = new Array(numberStars).fill("star");
            stars = stars.concat(
                new Array(5 - numberStars).fill("star_border")
            );
        } else {
            numberStars = (value - 1) / 2;
            stars = new Array(numberStars).fill("star");
            stars.push("star_half");
            stars = stars.concat(
                new Array(4 - numberStars).fill("star_border")
            );
        }

        return stars;
    }

    get effectiveness(): string {
        if (this.question.effectiveness! > 0) {
            return roundNumber(this.question.effectiveness!, 1);
        } else {
            return "-";
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/questions/QuestionDetails.vue